const initialState = [];

const searchUserListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SEARCH_USER_LIST":
      return action.data;
    default:
      return state;
  }
};

export default searchUserListReducer;
